$(window).on('load', function() {
    const overlay = document.querySelector('.gift-overlay');
    const modalNavbar = document.querySelector('.js-gift-modal-navbar');
    const stickyTitle = document.querySelector('.sticky-navbar-title');
    const close = document.querySelector('.close');
    const back = document.querySelector('.back');

    const navbarOffset = 24;

    window.addEventListener("message", (event) => {
        const overlay = document.querySelector('.gift-overlay');
        const stickyTitle = document.querySelector('.sticky-navbar-title');

        if (event.data.title) {
            if (event.data.title === "none") {
                addClass(modalNavbar, 'transparent');
                removeClass(modalNavbar, 'sticky');
            } else {
                stickyTitle.textContent = event.data.title;
                modalNavbar.classList.remove('transparent');
                close.classList.remove('hidden');
            }
        }
    })

    if (overlay) {
        overlay.addEventListener('scroll', function(e) {
            if (!modalNavbar.classList.contains('transparent')) {
                if (e.target.scrollTop > navbarOffset) {
                    addClass(modalNavbar, 'sticky');
                } else {
                    removeClass(modalNavbar, 'sticky');
                }
            }
        })
    }

    function addClass(element, className) {
        if (element)
            element.classList.add(className);
    }

    function removeClass(element, className) {
        if (element)
            element.classList.remove(className);
    }

    function formatOranisationsnummerInput(event) {
        let input = event.target.value;
        input = input.replace(/[^\d-]/g, '');
    
        if (input.length > 6 && input[6] !== '-') {
            input = input.slice(0, 6) + '-' + input.slice(6);
        }
    
        if (input.length > 11) {
            input = input.slice(0, 11);
        }
    
        event.target.value = input;
    }
    
    function validateOranisationsnummerInput(inputField) {
        const regex = /^\d{6}-\d{4}$/;
    
        if (!regex.test(inputField.value)) {
            
            return false;
        }
    
        return true;
    }

    $('body').on('input', '#input_1_34', function(e) {
        const fieldWrapper = this.closest('#field_1_34');
        const validationMessageId = 'validation_message_1_34';

        formatOranisationsnummerInput(e);
        const isValid = validateOranisationsnummerInput(this);
        const existingMessage = document.getElementById(validationMessageId);

        if (!isValid) {
            this.setAttribute('aria-invalid', 'true');
            if (!existingMessage) {
                const validationMessage = document.createElement('div');
                validationMessage.id = validationMessageId;
                validationMessage.className = 'gfield_description validation_message gfield_validation_message';
                validationMessage.textContent = 'Organisationsnummer måste vara i formatet NNNNNN-NNNN';
                fieldWrapper.appendChild(validationMessage);
            }
        } else {
            this.setAttribute('aria-invalid', 'false');
            if (existingMessage) {
                existingMessage.remove();
            }
        }

    })
})


// WEBPACK FOOTER //
// ./_src/js/gift-navbar.js